/* SEASON — Judge.me text tidy (Revamp widget)

   Two jobs CSS cannot do:

   1. Dates render US-style (07/15/2026) and Judge.me offers no long-form
      option. Rewritten to British long form (15 July 2026). Works on whole
      elements and on dates embedded mid-sentence ("Answer from Season:
      09/12/2026"), which is how the Q&A block renders them.
   2. The Q&A tab prints "Ask a question about this product" above a button
      that already says so. Removed.

   Runs on load, on every widget mutation, and on a short repeating pass,
   because Judge.me re-renders after its own scripts settle.
*/
(function () {
  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  var DATE = /\b(\d{1,2})\/(\d{1,2})\/(\d{4})\b/g;
  var PROMPT = 'ask a question about this product';

  function toBritish(_, mm, dd, yyyy) {
    var month = Number(mm) - 1;
    var day = Number(dd);
    if (month < 0 || month > 11 || day < 1 || day > 31) return _;
    return day + ' ' + MONTHS[month] + ' ' + yyyy;
  }

  function formatDates(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || node.nodeValue.indexOf('/') === -1) continue;
      var next = node.nodeValue.replace(DATE, toBritish);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function hidePrompt(root) {
    root.querySelectorAll('p, span, div, h2, h3').forEach(function (el) {
      if (el.children.length) return;
      if (el.textContent.trim().toLowerCase() === PROMPT) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function tidy(root) {
    formatDates(root);
    hidePrompt(root);
  }

  function start() {
    var widget = document.querySelector('.jm-review-widget');
    if (!widget) return false;
    tidy(widget);

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        tidy(widget);
      });
    }).observe(widget, { childList: true, subtree: true });

    var passes = 0;
    var settle = setInterval(function () {
      tidy(widget);
      if (++passes > 20) clearInterval(settle);
    }, 500);

    return true;
  }

  if (start()) return;

  var tries = 0;
  var poll = setInterval(function () {
    if (start() || ++tries > 40) clearInterval(poll);
  }, 250);
})();